import { useTranslation } from "react-i18next";
import { FlaskConical } from "lucide-react";
import { Button } from "@/shared/components/ui/button";

interface UserTestAccountSectionProps {
  /** ADR-0009 prod test partition flag, already normalised (absent reads as "real"). */
  readonly isTestAccount: boolean;
  readonly onToggle: () => void;
}

/** The admin-only test-partition card (ADR-0009): current state plus the toggle entry point. */
export function UserTestAccountSection({ isTestAccount, onToggle }: UserTestAccountSectionProps) {
  const { t } = useTranslation();
  return (
    <section
      data-testid="user-detail-test-account"
      className="rounded-lg border border-border bg-card p-6"
    >
      <h2 className="brand-eyebrow mb-4">{t("users.testAccount.label")}</h2>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="max-w-lg space-y-1">
          <p className="font-sans text-sm font-medium text-foreground">
            {isTestAccount ? t("users.testAccount.statusOn") : t("users.testAccount.statusOff")}
          </p>
          <p className="font-sans text-sm font-normal text-muted-foreground">
            {t("users.testAccount.description")}
          </p>
        </div>
        <Button data-testid="open-test-account-toggle" variant="outline" onClick={onToggle}>
          <FlaskConical className="mr-2 h-4 w-4" />
          {isTestAccount ? t("users.testAccount.disable") : t("users.testAccount.enable")}
        </Button>
      </div>
    </section>
  );
}
